export const azureBaseUrl =
  process.env.NODE_ENV === "development" ? " http://localhost:3004/" : "https://subscriptionfunctionsapp20230109142412.azurewebsites.net/api/";

// export const captchaBaseUri = "https://api.eucaptcha.eu/api/";
// export const captchaBaseUri = "https://testapi.eucaptcha.eu/api/";
export const captchaBaseUri = "https://captcha.bamacgroup.net/api/";
//: "https://eucaptcha2023012510501.azurewebsites.net/api/";
